import React,{useState,useEffect} from 'react';
import {currentDateFormat,dateFormat} from "../utils";
import { Card, CardContent, Typography,Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,Avatar } from '@mui/material';
import { School } from '@mui/icons-material';
import groupDriver from '../assets/images/group-driver.png';
import axios from 'axios';
import { GET_DRIVERS_COUNT,GET_SCHEDULE_COUNT,
         GET_VEHICLE_COUNT,
         GET_MAINTENANCE_VEHICLE_COUNT,
         GET_UPCOMING_SCHEDULE,
         GET_TRIP_DETAILS ,
         GET_TODAYS_TRIP_DETAILS} from '../constant'; 
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import { Base64 } from 'js-base64';
import MultipleMapComponent from '../components/MultipleMapComponent';

function Dashboard() {
  const dispatch = useDispatch();
  const [currentDate,setCurrentDate] = useState(new Date());
  const [drversCount,setDrivresCount] = useState(0);
  const [todayScheduleCount,setTodayScheduleCount] = useState(0);
  const [totalVehicleCount,setTotalVehicleCount] = useState(0);
  const [maintenanceVehicle,setMaintenanceVehicle] = useState('');
  const [scheduleDetails,setScheduleDetails] = useState();
  const [route, setRoute] = useState();
  const [tripPendingCount, setTripPendingCount] = useState(0);
  const [tripProgressCount, setTripProgressCount] = useState();
  const [tripCompletedCount, setTripCompletedCount] = useState();
  const [tripsTotalAmount, setTripsTotalAmount] = useState();
  useEffect(() => {
     dispatch(setLoading(true));
    const loadUser = async ()=>{
      const response_1 = await axios.get(GET_DRIVERS_COUNT);
      const response_2 = await axios.get(GET_SCHEDULE_COUNT);
      const response_3 = await axios.get(GET_VEHICLE_COUNT);
      const response_4 = await axios.get(GET_MAINTENANCE_VEHICLE_COUNT);
      const response_5 = await axios.get(GET_UPCOMING_SCHEDULE);
      const response_6 = await axios.get(GET_TRIP_DETAILS);
      const response_7 = await axios.get(GET_TODAYS_TRIP_DETAILS);
      console.log("response_7.length",response_7.data?.data);
      setDrivresCount(response_1.data);
      setTodayScheduleCount(response_2.data);
      setTotalVehicleCount(response_3.data);
      setScheduleDetails(response_5.data);
      setRoute(response_6.data);
      setTripPendingCount(response_7.data?.data?.schedulePendingCount);
      setTripProgressCount(response_7.data?.data?.TripsCounts[0]?.completedTripsCount);
      setTripCompletedCount(response_7.data?.data?.TripsCounts[0]?.progressTripsCount);
      setTripsTotalAmount(response_7.data?.data?.sumOfTripAmnt);
      //setTripProgressCount(response_7.data.TripsCounts[0]?.schedulePendingCount)
      //setMaintenanceVehicle(response_4.data);
      try{
      const vehiclesNeedingMaintenance = response_4.data.data.filter(vehicle => {
        const components = JSON.parse(JSON.parse(vehicle.component));
        return components.some(component => component.answer != '1');
      }).map(vehicle => ({
        vehicle_name: vehicle.vehicleDetails.vehicle_name,
        vehicle_id: vehicle.vehicle_id,
        last_update_date: vehicle.inspection_date,
      }));

      setMaintenanceVehicle(vehiclesNeedingMaintenance);
      
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
      dispatch(setLoading(false));
    }
       dispatch(setLoading(false));
    }
  loadUser();
  }, []);



  return (
    <><section>

      <div className='d-flex justify-content-between form-container'>
        <div>
          <h2 className="fs-5 font-weight-600">Dashboard  </h2>
        </div>
        <div>
          <span>{currentDateFormat(currentDate)}</span>
        </div>
      </div>
    </section>
    <div className="container-fluid px-mobile-2  px-5 py-4">
    <section>
          <div className="row">
            <div className="col-sm-6 col-md-3 col-lg-3 mb-4">
              <Link to="/home/driver/list" style={{ textDecoration: 'none' }}>
                <Card style={{ minWidth: 200, maxWidth: 300, backgroundColor: '#30876a' }}>
                  <CardContent style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={groupDriver} style={{ width: '77px' }} />
                    <div>
                      <Typography variant="h6" component="div" style={{ color: '#fff',paddingLeft:'30px' }}>
                        Total Drivers
                      </Typography>
                      <Typography variant="h4" component="div" style={{ color: '#fff', textAlign: 'center',marginTop:'5px' }}>
                        {drversCount.driverCount}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </div>
            <div className="col-sm-6 col-md-3 col-lg-3 mb-4">
              <Link to="/home/schedule/list" style={{ textDecoration: 'none' }}>
                <Card style={{ minWidth: 200, maxWidth: 300, backgroundColor: '#30876a' }}>
                  <CardContent style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={groupDriver} style={{ width: '77px' }} />
                    <div>
                      <Typography variant="h6" component="div" style={{ color: '#fff',paddingLeft:'10px' }}>
                        Today's Schedule
                      </Typography>
                      <Typography variant="h4" component="div" style={{ color: '#fff', textAlign: 'center',marginTop:'5px' }}>
                        {todayScheduleCount.scheduleCount}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </div>
            
            <div className="col-sm-6 col-md-3 col-lg-3 mb-4">
              <Link to="/home/vehicle/list" style={{ textDecoration: 'none' }}>
                <Card style={{ minWidth: 200, maxWidth: 300, backgroundColor: '#30876a' }}>
                  <CardContent style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={groupDriver} style={{ width: '77px' }} />
                    <div>
                      <Typography variant="h6" component="div" style={{ color: '#fff',paddingLeft:'30px' }}>
                        Total Vehicles
                      </Typography>
                      <Typography variant="h4" component="div" style={{ color: '#fff', textAlign: 'center',marginTop:'5px' }}>
                        {totalVehicleCount.vehicleCount}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </div>
            <div className="col-sm-6 col-md-3 col-lg-3 mb-4">
              <Link to="/home/schedule/list" style={{ textDecoration: 'none' }}>
                <Card style={{ minWidth: 200, maxWidth: 300, backgroundColor: '#30876a' }}>
                  <CardContent style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={groupDriver} style={{ width: '77px' }} />
                    <div>
                      <Typography variant="h6" component="div" style={{ color: '#fff',paddingLeft:'10px' }}>
                        Today's Schedule
                      </Typography>
                      <Typography variant="h4" component="div" style={{ color: '#fff', textAlign: 'center',marginTop:'5px' }}>
                        {todayScheduleCount.scheduleCount}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 mb-4"></div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-12 bg-white" style={{marginBottom:'15px'}}>
               {/* <Card style={{background:'#dddada' }} className='box-padding'>
                  <CardContent style={{ display: 'flex', alignItems: 'center' }}> */}
                   <Typography variant="h6" component="div" style={{ color: '#000', fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>
                Today's Schedule
              </Typography>
                  <TableContainer sx={{boxShadow:'none'}}>
                    <Table sx={{border:'1px solid #31876f33'}}>
                      <TableHead>
                        <TableRow>
                          {/* <TableCell sx={{fontWeight: 'bold' }}>No</TableCell> */}
                          <TableCell sx={{fontWeight: 'bold',padding:'5px' }}>Driver Name</TableCell>
                          <TableCell sx={{fontWeight: 'bold',padding:'5px' }}>Passenger Name</TableCell>
                          {/* <TableCell sx={{fontWeight: 'bold' }}>Number of Leg</TableCell> */}
                          <TableCell sx={{fontWeight: 'bold',padding:'5px' }}>Pickup/Dropoff Details</TableCell>
                          {/* <TableCell sx={{fontWeight: 'bold' }}>Payer</TableCell> */}
                          <TableCell sx={{fontWeight: 'bold',padding:'5px' }}>Trip Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {scheduleDetails && scheduleDetails.length > 0 ? ( scheduleDetails.map((details, index) => (
                          <TableRow key={index}>
                            {/* <TableCell>{index + 1}</TableCell> */}
                            <TableCell>
                              {details.driver ? (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <Avatar alt={details.driver.firstName} src={details.driver.avatarUrl} style={{ marginRight: '10px' }} />
                                  <a
                                    href={`/home/driver/profile/id?profilId=${Base64.encode(details.driver.driver_id)}`} // Replace with the correct route
                                    target="_blank" // Open in a new tab
                                    rel="noopener noreferrer" // Security best practice
                                    style={{ textDecoration: 'none', color: 'inherit' }} // Optional: Style the link
                                  >
                                  {details.driver.firstName + ' ' + details.driver.middleName + ' ' + details.driver.lastName}
                                </a>
                                </div>
                              ) : (
                                'No driver assigned'
                              )}
                            </TableCell>
                            <TableCell>
                            <a href={`/home/passenger/profile/id?profilId=${Base64.encode(details?.passenger?.passenger_id)}`} // Replace with the correct route
                                    target="_blank" // Open in a new tab
                                    rel="noopener noreferrer" // Security best practice
                                    style={{ textDecoration: 'none', color: 'inherit' }} // Optional: Style the link
                                  >
                              {details.passenger ? (details.passenger?.firstName + ' ' + 
                                      (details.passenger?.middleName ?? '') + ' ' + 
                                      (details.passenger?.lastName ?? '') + '-'+details.passenger?.passenger?.pass_pmi_no ) : ''}
                            </a>
                            </TableCell>
                            {/* <TableCell>{details.no_of_leg}</TableCell> */}
                           
                            <React.Fragment key={index}>
                            <TableCell>
                            {details.transData && details.transData.length > 0 ? (
                              
                                  details.transData.map((leg, legArrayIndex) => (
                                    <div key={legArrayIndex}>
                                      {/* {legArray.map((leg, legIndex) => ( */}
                                        <div key={legArrayIndex}>
                                          <span style={{marginTop:'10px',fontWeight:'bold',textDecoration:'underline'}}>Leg {legArrayIndex + 1}</span><br />
                                          <span style={{color:'#105c64',fontStyle:'italic',fontWeight:'lighter'}}>Pickup Location:</span> 
                                            {leg.pickupLocation?.pickup_location && (leg.pickupLocation.pickup_location.replace(/,,/, '') + ', ')} 
                                            {leg.pickupLocation?.pickup_address && (leg.pickupLocation.pickup_address.replace(/,,/, '') + ', ')} 
                                            {leg.pickupLocation?.pickup_city && (leg.pickupLocation.pickup_city.replace(/,,/, '') + ', ') }
                                            {leg?.pickupLocation?.state_master_list?.pickup_state_name && (leg?.pickupLocation?.state_master_list?.pickup_state_name.replace(/,,/, '') + ', ') } 
                                            {(leg?.pickupLocation?.pickup_zip || '')}<br />
                                          <span style={{color:'#105c64',fontStyle:'italic',fontWeight:'lighter'}}>Pickup Time:</span> {leg.pick_up_time}<br />
                                          <span style={{color:'#105c64',fontStyle:'italic',fontWeight:'lighter'}}>Drop Off Location:</span> 
                                            {leg.dropoffLocation?.dropoff_location && (leg.dropoffLocation?.dropoff_location.replace(/,,/, '') + ', ') }
                                            {leg.dropoffLocation?.dropoff_address && (leg.dropoffLocation?.dropoff_address.replace(/,,/, '') + ', ')}
                                            {leg.dropoffLocation?.dropoff_city && (leg.dropoffLocation?.dropoff_city.replace(/,,/, '') + ', ') } 
                                            {leg?.dropoffLocation?.state_master_list?.dropOff_state_name && (leg?.dropoffLocation?.state_master_list?.dropOff_state_name.replace(/,,/, '') + ', ') }
                                            {leg.dropoffLocation?.dropoff_zip}
                                          <br />
                                          <span style={{color:'#105c64',fontStyle:'italic',fontWeight:'lighter'}}>Drop Off Time:</span> {leg.drop_off_time}<br />
                                        </div>
                                      {/* )) */}
                                    </div>
                                  ))) : (
                                  <div>No legs available</div> // Handle the case where there are no legs
                                )}
                                 </TableCell>
                                 <TableCell>
                                 {details.transData.map((leg, legStatusIndex) => (
                                    <div key={legStatusIndex}
                                         style={{paddingTop: legStatusIndex === 0 ? '0' : '6em',
                                                 color: leg.trip_status && leg.trip_status === 1 ? 'green' : 'red',
                                                 fontWeight:'bold'}}>
                                    {leg.trip_status && leg.trip_status === 1 ? 'Completed' : 'Pending'}
                                     
                                    </div>
                                  ))}
                                 </TableCell>
                                </React.Fragment>
                           
                            {/* <TableCell>{details.passenger?.passenger?.payers?.payer_name}</TableCell> */}
                           
                          </TableRow>
                        ))) : <TableRow><TableCell colSpan={5} style={{ textAlign: 'center' }}>No data available</TableCell></TableRow>}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* </CardContent>
                </Card> */}
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 mb-5 bg-white" style={{paddingBottom:'12px'}}>
               <Typography variant="h6" component="div" style={{ color: '#000',fontSize:'16px',fontWeight:'bold',padding:'10px' }}>
                      Vehicle Requires Maintenance
                      </Typography>
                      <TableContainer sx={{boxShadow:'none'}}>
                    <Table sx={{border:'1px solid #31876f33'}}>
                      
                      <TableBody>
                        {maintenanceVehicle && maintenanceVehicle.length > 0 ? ( maintenanceVehicle.map((vehicle, index) => (
                          <TableRow key={index}>
                            {/* <TableCell>{index + 1}</TableCell> */}
                            <TableCell>
                            <a href={`/home/vehicle/report?vehicleName=${Base64.encode(vehicle.vehicle_name)}&vehicleId=${Base64.encode(vehicle.vehicle_id)}`}>
                            {vehicle.vehicle_name}</a>
                            </TableCell>
                            <TableCell>{dateFormat(vehicle.last_update_date)}</TableCell>
                            
                          </TableRow>
                        ))) : <TableRow><TableCell colSpan={2} style={{ textAlign: 'center' }}>No data available</TableCell></TableRow>}
                      </TableBody>
                    </Table>
                    </TableContainer>
                  {/* </CardContent> */}
                {/* </Card> */}
              {/* </Link> */}
            </div>
            <div className="col-sm-6 col-md-4 col-lg-4 mb-5 bg-white" style={{paddingBottom:'12px'}}>
               <Typography variant="h6" component="div" style={{ color: '#000',fontSize:'16px',fontWeight:'bold',padding:'10px' }}>
                      Today's Trip Details
                      </Typography>
                      <TableContainer sx={{boxShadow:'none'}}>
                    <Table sx={{border:'1px solid #31876f33'}}>
                      
                      <TableBody>
                        
                          <TableRow><TableCell> Trips In Progress <strong>{`- ${tripProgressCount}`}</strong></TableCell></TableRow>
                          <TableRow><TableCell> Trips Completed <strong>{`- ${tripCompletedCount}`}</strong></TableCell></TableRow>
                          <TableRow><TableCell> Trips Pending <strong>{`- ${tripPendingCount}`}</strong></TableCell></TableRow>
                          <TableRow><TableCell> Trips Canceled</TableCell></TableRow>
                          <TableRow><TableCell> Trips Total Amount<strong>{`- $ ${tripsTotalAmount}`}</strong></TableCell></TableRow>
                          <TableRow><TableCell>Active Drivers    <strong>{`-  ${drversCount.driverCount}`}</strong></TableCell></TableRow>
                        
                      </TableBody>
                    </Table>
                    </TableContainer>
                  {/* </CardContent> */}
                {/* </Card> */}
              {/* </Link> */}
            </div>

            <Typography variant="h6" component="div" 
                        style={{ color: '#000',paddingLeft:'10px',textDecoration:'underline',fontWeight:'bold',marginTop:'10px' }}>
              Completed Trips - Today
            </Typography>
            {
              <MultipleMapComponent routes={route} />
            }
            
          </div>
        </section>
      </div>
    </>
  )
}

export default Dashboard